import React, { createContext, useContext } from 'react';

const EnvironmentContext = createContext(null);

export const EnvironmentProvider = ({ children }) => {
  const environmentState = {
    isDevelopmentEnv: process.env.NODE_ENV === 'development',
    isProductionEnv: process.env.NODE_ENV === 'production',
    currentEnv: process.env.NODE_ENV
  };

  return (
    <EnvironmentContext.Provider value={environmentState}>
      {children}
    </EnvironmentContext.Provider>
  );
};

// Custom hook to use the environment context
export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (context === null) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
};
